import React from 'react'
import { SongData } from '../types'
import { SongManager } from '../services/SongManager'

interface SongControlsProps {
	lyricsInput: string;
	onLyricsInputChange: (value: string) => void;
	onLyricsSubmit: () => void;
	currentSong: SongData | null;
	onShowSongPicker: () => void;
	onShowEmojiDictionary: () => void;
}

export const SongControls: React.FC<SongControlsProps> = ({
	lyricsInput,
	onLyricsInputChange,
	onLyricsSubmit,
	currentSong,
	onShowSongPicker,
	onShowEmojiDictionary,
}) => {
	const stopper = (e: React.KeyboardEvent) => e.stopPropagation()

	const handleInsertEmojis = () => {
		if (!lyricsInput.trim()) return

		const processedLyrics = SongManager.processLyricsWithEmojis(lyricsInput)
		onLyricsInputChange(processedLyrics)
	}

	return (
		<div className="lyrics-input-section">
			<div className="current-song-info">
				{currentSong && (
					<>
						<span className="current-song-title">{currentSong.title}</span>
						<button
							onClick={onShowSongPicker}
							className="btn btn-secondary btn-small"
						>
							Switch Song
						</button>
					</>
				)}
			</div>

			<label htmlFor="lyrics-input">Paste your lyrics here:</label>
			<textarea
				id="lyrics-input"
				value={lyricsInput}
				onChange={(e) => onLyricsInputChange(e.target.value)}
				placeholder="Paste song lyrics here..."
				rows={6}
				onKeyDown={stopper}
			/>
			<div className="lyrics-buttons">
				<div className="emoji-button-group">
					<button onClick={handleInsertEmojis} className="btn btn-secondary">
						🎭 Insert Emojis
					</button>
					<button
						onClick={onShowEmojiDictionary}
						className="btn btn-secondary btn-icon"
						title="Manage emoji dictionary"
					>
						⚙️
					</button>
				</div>
				<button onClick={onLyricsSubmit} className="btn btn-primary">
					Update Lyrics
				</button>
			</div>
		</div>
	)
}
